// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type AllInfoTextsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllInfoTextsQuery = { allInfoTexts?: Array<{ id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } }> };

export type SingleInfoTextQueryVariables = Types.Exact<{
  infoTextId: Types.Scalars['String']['input'];
}>;


export type SingleInfoTextQuery = { singleInfoText?: { id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } } };

export type InfoTextDetailsFragment = { id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } };

export type UpdateInfoTextMutationVariables = Types.Exact<{
  infoText: Types.InfoTextInput;
}>;


export type UpdateInfoTextMutation = { updateInfoText?: { id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } } };

export type CreateInfoTextMutationVariables = Types.Exact<{
  infoText: Types.InfoTextInput;
}>;


export type CreateInfoTextMutation = { createInfoText?: { id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } } };

export type DeleteInfoTextMutationVariables = Types.Exact<{
  infoTextId: Types.Scalars['String']['input'];
}>;


export type DeleteInfoTextMutation = { deleteInfoText?: { id?: string, active: boolean, key?: string, comment?: string, title?: string, lastUpdated?: string, createdAt?: string, content?: { json?: string, html?: string } } };

export const InfoTextDetailsFragmentDoc = gql`
    fragment InfoTextDetails on InfoText {
  id
  active
  key
  comment
  title
  lastUpdated
  content {
    json
    html
  }
  createdAt
}
    `;
export const AllInfoTextsDocument = gql`
    query AllInfoTexts {
  allInfoTexts {
    ...InfoTextDetails
  }
}
    ${InfoTextDetailsFragmentDoc}`;

/**
 * __useAllInfoTextsQuery__
 *
 * To run a query within a React component, call `useAllInfoTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInfoTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInfoTextsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllInfoTextsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllInfoTextsQuery, AllInfoTextsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllInfoTextsQuery, AllInfoTextsQueryVariables>(AllInfoTextsDocument, options);
      }
export function useAllInfoTextsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllInfoTextsQuery, AllInfoTextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllInfoTextsQuery, AllInfoTextsQueryVariables>(AllInfoTextsDocument, options);
        }
// @ts-ignore
export function useAllInfoTextsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllInfoTextsQuery, AllInfoTextsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllInfoTextsQuery, AllInfoTextsQueryVariables>;
export function useAllInfoTextsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllInfoTextsQuery, AllInfoTextsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllInfoTextsQuery | undefined, AllInfoTextsQueryVariables>;
export function useAllInfoTextsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllInfoTextsQuery, AllInfoTextsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllInfoTextsQuery, AllInfoTextsQueryVariables>(AllInfoTextsDocument, options);
        }
export type AllInfoTextsQueryHookResult = ReturnType<typeof useAllInfoTextsQuery>;
export type AllInfoTextsLazyQueryHookResult = ReturnType<typeof useAllInfoTextsLazyQuery>;
export type AllInfoTextsSuspenseQueryHookResult = ReturnType<typeof useAllInfoTextsSuspenseQuery>;
export type AllInfoTextsQueryResult = ApolloReactCommon.QueryResult<AllInfoTextsQuery, AllInfoTextsQueryVariables>;
export const SingleInfoTextDocument = gql`
    query SingleInfoText($infoTextId: String!) {
  singleInfoText(infoTextId: $infoTextId) {
    ...InfoTextDetails
  }
}
    ${InfoTextDetailsFragmentDoc}`;

/**
 * __useSingleInfoTextQuery__
 *
 * To run a query within a React component, call `useSingleInfoTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleInfoTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleInfoTextQuery({
 *   variables: {
 *      infoTextId: // value for 'infoTextId'
 *   },
 * });
 */
export function useSingleInfoTextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleInfoTextQuery, SingleInfoTextQueryVariables> & ({ variables: SingleInfoTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleInfoTextQuery, SingleInfoTextQueryVariables>(SingleInfoTextDocument, options);
      }
export function useSingleInfoTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleInfoTextQuery, SingleInfoTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleInfoTextQuery, SingleInfoTextQueryVariables>(SingleInfoTextDocument, options);
        }
// @ts-ignore
export function useSingleInfoTextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleInfoTextQuery, SingleInfoTextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleInfoTextQuery, SingleInfoTextQueryVariables>;
export function useSingleInfoTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleInfoTextQuery, SingleInfoTextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleInfoTextQuery | undefined, SingleInfoTextQueryVariables>;
export function useSingleInfoTextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleInfoTextQuery, SingleInfoTextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleInfoTextQuery, SingleInfoTextQueryVariables>(SingleInfoTextDocument, options);
        }
export type SingleInfoTextQueryHookResult = ReturnType<typeof useSingleInfoTextQuery>;
export type SingleInfoTextLazyQueryHookResult = ReturnType<typeof useSingleInfoTextLazyQuery>;
export type SingleInfoTextSuspenseQueryHookResult = ReturnType<typeof useSingleInfoTextSuspenseQuery>;
export type SingleInfoTextQueryResult = ApolloReactCommon.QueryResult<SingleInfoTextQuery, SingleInfoTextQueryVariables>;
export const UpdateInfoTextDocument = gql`
    mutation UpdateInfoText($infoText: InfoTextInput!) {
  updateInfoText(infoText: $infoText) {
    ...InfoTextDetails
  }
}
    ${InfoTextDetailsFragmentDoc}`;
export type UpdateInfoTextMutationFn = ApolloReactCommon.MutationFunction<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>;

/**
 * __useUpdateInfoTextMutation__
 *
 * To run a mutation, you first call `useUpdateInfoTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfoTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfoTextMutation, { data, loading, error }] = useUpdateInfoTextMutation({
 *   variables: {
 *      infoText: // value for 'infoText'
 *   },
 * });
 */
export function useUpdateInfoTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>(UpdateInfoTextDocument, options);
      }
export type UpdateInfoTextMutationHookResult = ReturnType<typeof useUpdateInfoTextMutation>;
export type UpdateInfoTextMutationResult = ApolloReactCommon.MutationResult<UpdateInfoTextMutation>;
export type UpdateInfoTextMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInfoTextMutation, UpdateInfoTextMutationVariables>;
export const CreateInfoTextDocument = gql`
    mutation CreateInfoText($infoText: InfoTextInput!) {
  createInfoText(infoText: $infoText) {
    ...InfoTextDetails
  }
}
    ${InfoTextDetailsFragmentDoc}`;
export type CreateInfoTextMutationFn = ApolloReactCommon.MutationFunction<CreateInfoTextMutation, CreateInfoTextMutationVariables>;

/**
 * __useCreateInfoTextMutation__
 *
 * To run a mutation, you first call `useCreateInfoTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInfoTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInfoTextMutation, { data, loading, error }] = useCreateInfoTextMutation({
 *   variables: {
 *      infoText: // value for 'infoText'
 *   },
 * });
 */
export function useCreateInfoTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInfoTextMutation, CreateInfoTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInfoTextMutation, CreateInfoTextMutationVariables>(CreateInfoTextDocument, options);
      }
export type CreateInfoTextMutationHookResult = ReturnType<typeof useCreateInfoTextMutation>;
export type CreateInfoTextMutationResult = ApolloReactCommon.MutationResult<CreateInfoTextMutation>;
export type CreateInfoTextMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInfoTextMutation, CreateInfoTextMutationVariables>;
export const DeleteInfoTextDocument = gql`
    mutation DeleteInfoText($infoTextId: String!) {
  deleteInfoText(infoTextId: $infoTextId) {
    ...InfoTextDetails
  }
}
    ${InfoTextDetailsFragmentDoc}`;
export type DeleteInfoTextMutationFn = ApolloReactCommon.MutationFunction<DeleteInfoTextMutation, DeleteInfoTextMutationVariables>;

/**
 * __useDeleteInfoTextMutation__
 *
 * To run a mutation, you first call `useDeleteInfoTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInfoTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInfoTextMutation, { data, loading, error }] = useDeleteInfoTextMutation({
 *   variables: {
 *      infoTextId: // value for 'infoTextId'
 *   },
 * });
 */
export function useDeleteInfoTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInfoTextMutation, DeleteInfoTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInfoTextMutation, DeleteInfoTextMutationVariables>(DeleteInfoTextDocument, options);
      }
export type DeleteInfoTextMutationHookResult = ReturnType<typeof useDeleteInfoTextMutation>;
export type DeleteInfoTextMutationResult = ApolloReactCommon.MutationResult<DeleteInfoTextMutation>;
export type DeleteInfoTextMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInfoTextMutation, DeleteInfoTextMutationVariables>;